import type { ReactNode } from 'react';

interface TaskPropertyRowProps {
  label: string;
  children: ReactNode;
}

/**
 * One labelled row in the task's property list.
 *
 * A fixed height and no divider: seven of these read as a block of facts about
 * the task, where seven ruled rows would read as a table of seven records.
 */
export const TaskPropertyRow = ({ label, children }: TaskPropertyRowProps) => (
  <div className="flex h-[42px] items-center gap-3.5">
    <span className="w-[82px] shrink-0 text-[12.5px] text-[#9A9A9A]">{label}</span>
    <div className="flex min-w-0 flex-1 items-center gap-1.5">{children}</div>
  </div>
);
